export enum FeatureFlagValue {
  On = "true",
  Off = "false",
}

// There are additional flags defined in CCS, but none of them are utilized in the FE code
export enum FeatureFlagName {
  FTE30785EnableSharedWorkspaceProjectType = "FTE-30785_enableSharedWorkspaceProjectType",
  ShowTranslateMenu = "FTE-5071-showTranslateMenu",
  FTE33876EnableSanitizeFileUploading = "FTE-33876_enableSanitizeFileUploading",
  EnableExternalUserCreation = "FTE-44823-enableExternalUser",
  EnableEditStructureDocumentSectionTitle = "FTE-54155-enableEditStructuredDocumentSections",
  EnableEmailGroupMilestones = "FTE-55113-enableMilestoneEmails",
  EnableNewInlineUIEnhancements = "FTE-52967-enableNewInLineUIEnhancements",
  EnableIntegrationSync = "FTE-55449-integration-sync",
  EnableProjectAccessUI = "FTE-57836-project-access-ui",
  EnableSimplifyContent = "FTE-59796-simplify-content",
  EnableContentTableUIImprovements = "FTE-59803-content-table-ui-improvements",
  EnableDocumentToTemplateAI = "FTE-60242-doc-to-template-ai",
  EnableResendInvitations = "FTE-60403-resend-invitations",
}
